import { Component, OnInit, OnDestroy } from '@angular/core';
import { QuestionService, DynamicQuestions } from '../services/question/question.service';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormValuesService } from '../services/form-values/form-values.service';
import { ApiService } from '../services/api/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { QuestionPage } from '../question-page';
import { QuestionBase, QuestionElement } from '../question-base';
import { QuestionRoot } from '../question-root';
import { LocationStrategy } from '@angular/common';
import { CustomerEditService } from '../services/customer-edit/customer-edit.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-generic-form-page',
  templateUrl: './generic-form-page.component.html',
  styleUrls: ['./generic-form-page.component.css']
})
export class GenericFormPageComponent implements OnDestroy{

  private subscription : Subscription = null;
  private nettoSub : Subscription = null;
  
  ngOnDestroy(): void {
    if( this.subscription ){
      this.subscription.unsubscribe(); 
    }
    if( this.nettoSub ){
      this.nettoSub.unsubscribe(); 
    }
  }
  
  public dynamicQuestions: any = null;
  public userErrors = false;
  public apiWorking = false;

  private routerData: any = {};
  private questions: QuestionRoot;

  constructor(
    private questionService: QuestionService,
    private router: Router,
    private route: ActivatedRoute,
    private formValueService: FormValuesService,
    private apiService: ApiService,
    private customerEditService: CustomerEditService
  ) {
    if (this.router.url.split(';')[0] === "/kundenbearbeitung") {
      this.genForm();
    } else {
      this.route.data.subscribe((data) => {
        this.routerData = data;
        this.apiService.getForm().subscribe( (form: any) => {
          this.questions = questionService.questionsBuilder( form.result[0].Formdata);  
          this.questions.forEach((elem: QuestionBase<any>): void => {
            if (formValueService.hasValue(elem.key)) {
              elem.setValue(formValueService.getValue(elem.key));
            }
            if (formValueService.hasValue(elem.key + '_dirty')) {
              elem.setDirty();
            }
          });
          this.dynamicQuestions = this.questions.getPage(data.pageNr);
        });
    
      });
      this.nettoCalc();
    }
  }
  
  private genForm() {
    this.route.params.subscribe(
      (params) => {
        let currentParams = Object.assign({}, params);
        if (!currentParams.copy){
          currentParams.copy = false;
        } 
        let customerFormdata = this.customerEditService.getCustomerFormdata(currentParams.id,currentParams.copy);          
        this.setForm(customerFormdata);   
        this.subscription = this.customerEditService.updateForm$.subscribe( () => {
          customerFormdata[0].items = this.customerEditService.addKidCustomerFormData(customerFormdata[0].items);
          for(let questionKey in this.dynamicQuestions.questions) {
            customerFormdata[0].items.forEach( (question, index) => {
              if( question.jsonName === questionKey ){         
                if( this.dynamicQuestions.questions[questionKey].controlAssociated ){                                         
                  customerFormdata[0].items[index].sampleValue = this.dynamicQuestions.questions[questionKey].controlAssociated.value;                  
                } else {
                  customerFormdata[0].items[index].sampleValue = this.dynamicQuestions.questions[questionKey].standardValue;
                }             
              }
            });         
          };          
          this.setForm(customerFormdata);        
          this.customerEditService.dissolver(this.questions.pages[1].questions);         
        });
      }
    );
  }
  
  public setForm(customerFormdata) {
    this.questions = this.questionService.questionsBuilder(customerFormdata);
    this.dynamicQuestions = this.questions.getPage("1");
  }
  
  public dynamicFormSubmitted(submitVal: any) {
    if (this.routerData.nextUrl) {
      this.router.navigateByUrl(this.routerData.nextUrl);
    } else if (this.routerData.isLastUrl) {
      let apiRequestObject = {};

      this.questions.getQuestionsFlatArr().forEach((elem) => {
        apiRequestObject[elem.key] = elem.getValueForRequest();
      });

      apiRequestObject = this.formValueService.sanitizeRequestValues(apiRequestObject);
      this.apiWorking = true;
      this.apiService.requestAll(apiRequestObject).then((response) => {
        this.router.navigateByUrl('/auswertung');
        this.apiWorking = null;
      }, (error: HttpErrorResponse) => {
        alert('Fehler: ' + error.message + error.statusText);
        console.error(error);
        this.apiWorking = null;
      });

    }
  }
  
  public nettoCalc(){
    this.nettoSub = this.apiService.calcNetto$.subscribe( ( finishedFunc ) => {
      let nettoRequestObject = {};
      this.questions.getQuestionsFlatArr().forEach((elem) => {
        nettoRequestObject[elem.key] = elem.getValueForRequest();
      });
      this.apiService.setNettoValues(nettoRequestObject);
      finishedFunc();
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/generic-form-page/generic-form-page.component.ts